import { Head, router } from '@inertiajs/react'
import { useState } from 'react'
import ConfirmDialog from '../../components/ConfirmDialog'
import EventLayout from '../../components/EventLayout'

type EventPayload = {
  id: number
  title: string
  slug: string
  location: string
  date_range: string
  status: 'upcoming' | 'ongoing' | 'completed'
  banner_url: string | null
}

type Props = {
  event: EventPayload
  events: Array<{ title: string; slug: string }>
  can_delete: boolean
}

export default function Settings({ event, events, can_delete }: Props) {
  const [deleteOpen, setDeleteOpen] = useState(false)

  return (
    <>
      <Head title={`Settings — ${event.title}`} />
      <EventLayout event={event} events={events} active="settings">
        <h2 className="font-display text-2xl font-bold tracking-tight text-ink">Settings</h2>

        <div className="mt-8 rounded-xl border border-rose-200 bg-white p-6">
          <h3 className="font-display text-base font-semibold text-rose-600">Danger Zone</h3>
          <div className="mt-3 flex flex-col gap-4 sm:flex-row sm:items-center sm:justify-between">
            <div>
              <p className="font-display text-sm font-medium text-gray-900">Delete this event</p>
              <p className="mt-0.5 font-display text-sm text-gray-600">
                {can_delete
                  ? 'Permanently delete this event and all its form configuration. This cannot be undone.'
                  : 'This event contains leads and cannot be deleted. Please delete all associated leads before attempting to remove this event.'}
              </p>
            </div>
            <button
              type="button"
              disabled={!can_delete}
              onClick={() => setDeleteOpen(true)}
              className="shrink-0 rounded-md border border-rose-300 bg-white px-4 py-2 font-display text-sm font-medium text-rose-600 transition hover:bg-rose-50 disabled:cursor-not-allowed disabled:opacity-40"
            >
              Delete Event
            </button>
          </div>
        </div>

        <ConfirmDialog
          open={deleteOpen}
          title="Delete event?"
          body={<>This will permanently delete <strong>{event.title}</strong> and all its form steps. This action cannot be undone.</>}
          confirmLabel="Delete"
          tone="danger"
          onConfirm={() => {
            setDeleteOpen(false)
            router.delete(`/events/${event.id}`, {
              preserveScroll: true,
            })
          }}
          onClose={() => setDeleteOpen(false)}
        />
      </EventLayout>
    </>
  )
}
